import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, forwardRef, memo } from 'react';
import ScrollBar from '../../../../../utils/ScrollBar';
var CustomScrollbars = function CustomScrollbars(_ref) {
  var onScroll = _ref.onScroll,
    forwardedRef = _ref.forwardedRef,
    style = _ref.style,
    children = _ref.children;
  var refSetter = useCallback(function (scrollbarsRef) {
    if (scrollbarsRef) {
      forwardedRef(scrollbarsRef.view);
    } else {
      forwardedRef(null);
    }
  }, [forwardedRef]);
  return /*#__PURE__*/React.createElement(ScrollBar, {
    ref: refSetter,
    style: _objectSpread(_objectSpread({}, style), {}, {
      paddingRight: 12,
      overflow: 'hidden'
    }),
    onScroll: onScroll
  }, children);
};
var CustomScrollbarsVirtualList = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(CustomScrollbars, _extends({}, props, {
    forwardedRef: ref
  }));
});
export default /*#__PURE__*/memo(CustomScrollbarsVirtualList);